"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clear = exports.updateField = exports.removeFailed = exports.removeSuccess = exports.removeRequest = exports.validationFailed = exports.addFailed = exports.addSuccess = exports.addRequest = exports.fetchFailed = exports.fetchSuccess = exports.fetchRequest = void 0;
const ActionTypes = require("../../actionTypes/modelspace/customer");
// Fetch
const fetchRequest = (customerId) => ({
    type: ActionTypes.FETCH_REQUEST,
    payload: customerId
});
exports.fetchRequest = fetchRequest;
const fetchSuccess = (configuration) => ({
    type: ActionTypes.FETCH_SUCCESS,
    payload: configuration
});
exports.fetchSuccess = fetchSuccess;
const fetchFailed = (message) => ({
    type: ActionTypes.FETCH_FAILED,
    payload: message
});
exports.fetchFailed = fetchFailed;
// Add
const addRequest = (customerId, configuration) => ({
    type: ActionTypes.ADD_REQUEST,
    payload: {
        customerId,
        configuration
    }
});
exports.addRequest = addRequest;
const addSuccess = () => ({
    type: ActionTypes.ADD_SUCCESS
});
exports.addSuccess = addSuccess;
const addFailed = (message) => ({
    type: ActionTypes.ADD_FAILED,
    payload: message
});
exports.addFailed = addFailed;
const validationFailed = (message) => ({
    type: ActionTypes.VALIDATION_FAILED,
    payload: message
});
exports.validationFailed = validationFailed;
// Remove
const removeRequest = (customerId, configuration) => ({
    type: ActionTypes.REMOVE_REQUEST,
    payload: {
        customerId,
        configuration
    }
});
exports.removeRequest = removeRequest;
const removeSuccess = () => ({
    type: ActionTypes.REMOVE_SUCCESS
});
exports.removeSuccess = removeSuccess;
const removeFailed = (message) => ({
    type: ActionTypes.REMOVE_FAILED,
    payload: message
});
exports.removeFailed = removeFailed;
// Others
const updateField = (key, value) => ({
    type: ActionTypes.UPDATE_FIELD,
    payload: {
        key,
        value
    }
});
exports.updateField = updateField;
function clear() {
    return {
        type: ActionTypes.CLEAR
    };
}
exports.clear = clear;
//# sourceMappingURL=customer.js.map